import React from "react";
import styled from "styled-components";
import { COLORS } from "../../../assets/constants/styles";

export const TabsContainer = ({ children }) => {
  return <Container>{children}</Container>;
};

const Container = styled.div`
  display: flex;
  flex-direction: row;
  background-color: ${COLORS.lightViolet};
  align-items: center;
  padding: 0.375rem;
  gap: 0.25rem;
  border-radius: 0.75rem;
  margin-bottom: 1.5rem;
  width: fit-content;
`;
